module.exports = __webpack_public_path__ + "static/media/layers.1900f992.svg";